export default "__VITE_ASSET__D073gKrx__"